/**
 * Array that stores BreakpointMixin instances
 * Used to call handleBreakpoint methods when matchmedia change events fire
 */
let instances = [];

// Get breakpoints from the html after element (created by scss mixin)
const breakpoints = window
	?.getComputedStyle(document.querySelector('html'), ':after')
	?.getPropertyValue('content')
	?.replace(/"/g, '')
	?.split('|') || [];

// Set a default initial state that will be called when each component is connected
let initialState = [
	Math.max(breakpoints.length - 1, 0),
	null,
	breakpoints[breakpoints.length - 1]
];
let hasMatched = false;

// Handler for change event
const handleMediaQueryListChange = (index, mediaQueryList, breakpoint) => {
	for (let instance of instances) {
		instance?.handleBreakpoint(index, mediaQueryList, breakpoint);
	}
};

// Define event listeners and push initial state if match is found
for (let i = 0; i < breakpoints.length; i++) {
	const breakpoint = breakpoints[i];
	const mediaQueryList = window.matchMedia(breakpoint);

	mediaQueryList.addEventListener('change', handleMediaQueryListChange.bind(null, i, mediaQueryList, breakpoint));

	if (!hasMatched && mediaQueryList.matches) {
		initialState = [
			i,
			mediaQueryList,
			breakpoint
		];

		hasMatched = true;
	}
}

/**
 * Mixin used to expose `handleBreakpoint` method that fires whenever a breakpoint changes
 */
export const BreakpointMixin = superClass => class extends superClass {

	constructor () {
		super();
	}

	/**
	 * @param {number} index
	 * @param {MediaQueryList} mediaQueryList
	 * @param {string} breakpoint
	 */
	handleBreakpoint () {
		throw new Error('Not implemented');
	}

	connectedCallback () {
		super.connectedCallback();

		instances.push(this);
		this.handleBreakpoint(...initialState);
	}

	disconnectedCallback () {
		instances = instances.filter(instance => instance !== this);

		super.disconnectedCallback();
	}

};
